export const colors = {
  background: '#0a0a0a',
  backgroundSecondary: '#121212',
  card: '#1a1a1a',
  surface: '#252525',
  primary: '#FF6B35',
  primaryLight: '#FF8C5A',
  primaryDark: '#E55A25',
  accent: '#4ECDC4',
  textPrimary: '#FFFFFF',
  textSecondary: '#B0B0B0',
  textMuted: '#666666',
  border: '#333333',
  success: '#4CAF50',
  error: '#FF5252',
  warning: '#FFC107',

  // Game colors
  games: {
    magic: '#B8860B',
    pokemon: '#FFCB05',
    yugioh: '#7B68EE',
    lorcana: '#4169E1',
    onepiece: '#DC143C',
    dbs: '#FF4500',
  },
};

export const GAMES = [
  { id: 'magic', name: 'Magic: The Gathering', shortName: 'Magic', color: '#B8860B' },
  { id: 'pokemon', name: 'Pokémon TCG', shortName: 'Pokémon', color: '#FFCB05' },
  { id: 'yugioh', name: 'Yu-Gi-Oh!', shortName: 'Yu-Gi-Oh!', color: '#7B68EE' },
  { id: 'lorcana', name: 'Disney Lorcana', shortName: 'Lorcana', color: '#4169E1' },
  { id: 'onepiece', name: 'One Piece TCG', shortName: 'One Piece', color: '#DC143C' },
  { id: 'dbs', name: 'Dragon Ball Super', shortName: 'DBS', color: '#FF4500' },
  { id: 'altered', name: 'Altered', shortName: 'Altered', color: '#A8D8EA' },
  { id: 'fab', name: 'Flesh and Blood', shortName: 'FaB', color: '#C41E3A' },
  { id: 'riftbound', name: 'Riftbound', shortName: 'Riftbound', color: '#00CED1' },
  { id: 'starwars', name: 'Star Wars Unlimited', shortName: 'Star Wars', color: '#FFE81F' },
  { id: 'sorcery', name: 'Sorcery: Contested Realm', shortName: 'Sorcery', color: '#4A90D9' },
  { id: 'autre', name: 'Autre (à préciser)', shortName: 'Autre', color: '#888888' },
];

export const getGameById = (id) => GAMES.find(g => g.id === id);
export const getGameColor = (id) => getGameById(id)?.color || '#666';
export const getGameName = (id) => getGameById(id)?.name || id;

export const USER_ROLES = {
  VISITOR: 'Visiteur',
  PLAYER: 'Joueur',
  ORG: 'Organisateur',
  ARCANIEN: 'Arcanien',
  EDITOR: 'Éditeur',
  ADMIN: 'Administrateur',
};

export const FORMATS = {
  magic: ['Standard', 'Modern', 'Legacy', 'Pré-Modern', 'Commander Multi', 'Commander Duel', 'Commander Pauper', 'Pioneer', 'Draft', 'Sealed', 'Pauper', 'Avant-premiere'],
  pokemon: ['Standard', 'Expanded', 'Unlimited', 'Draft', 'GLC', 'Construit', 'Ligue', 'Avant-premiere'],
  yugioh: ['Advanced', 'Traditional', 'Speed Duel', 'Rush Duel', 'Master Duel', 'Construit', 'Avant-premiere'],
  lorcana: ['Core Constructed', 'Draft', 'Sealed', 'Pack Rush', 'Ligue', 'Avant-premiere'],
  onepiece: ['Standard', 'Draft', 'OP01-OP08', 'Construit', 'Avant-premiere'],
  dbs: ['Standard', 'Draft', 'Fusion World', 'Avant-premiere'],
  fab: ['Classic Constructed', 'Blitz', 'Commoner', 'Draft', 'Pit Fight', 'Avant-premiere'],
  riftbound: ['Construit', 'Multi Free for All', '2v2', 'Avant-premiere'],
  starwars: ['Premier', 'Draft', 'Sealed', 'Twin Suns', 'Construit', 'Avant-premiere'],
  sorcery: ['Construit', 'Sealed', 'Two-Headed Dragon', 'Avant-premiere'],
  altered: ['Standard', 'Draft', 'Sealed', 'Avant-premiere'],
  autre: [],
};
